// @TODO: Should remove unused/redundant variables
export const BOARD_WORKSPACE_ALLOWANCE = 800

export const CATEGORY_HERO_ASPECT_RATIO = '16:9'
export const CATEGORY_HERO_ASPECT_RATIO_MULTIPLIER = 9 / 16
export const CATEGORY_HERO_WIDTH = 80
export const CATEGORY_HERO_HEIGHT = 45
export const CATEGORY_HERO_X_TOTAL_PADDING = 8
export const CATEGORY_HERO_Y_TOTAL_PADDING = 8
export const CATEGORY_HERO_TOTAL_WIDTH = CATEGORY_HERO_WIDTH + CATEGORY_HERO_X_TOTAL_PADDING
export const CATEGORY_HERO_TOTAL_HEIGHT = CATEGORY_HERO_HEIGHT + CATEGORY_HERO_Y_TOTAL_PADDING
export const CATEGORY_HERO_CONTAINER_TOTAL_PADDING = 8

export const CATEGORY_HERO_INITIAL_COUNT = 3
export const CATEGORY_ROW_WIDTH = CATEGORY_HERO_TOTAL_WIDTH * (CATEGORY_HERO_INITIAL_COUNT + 1) // The + 1 comes from the "new" placeholder
export const CATEGORY_ROW_HEIGHT = CATEGORY_HERO_HEIGHT + CATEGORY_HERO_Y_TOTAL_PADDING
export const CATEGORY_BODY_INITIAL_WIDTH = CATEGORY_ROW_WIDTH + CATEGORY_HERO_Y_TOTAL_PADDING
export const CATEGORY_BODY_INITIAL_HEIGHT = CATEGORY_ROW_HEIGHT + CATEGORY_HERO_Y_TOTAL_PADDING

export const CATEGORY_SPACING = 96

export const ORDER_FIRST_BUFFER = 1024
export const ORDER_LAST_BUFFER = 1024
export const ORDER_BUFFER = 1024

export const CATEGORY_NAME_MAX_CHARACTERS = 31
